"use client";

import { Card, CardContent } from "@/components/ui/card";
import { Award, Clock, Shield } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhyChooseCarServiceConnecticut() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return;
}